import React, { useEffect, useState } from 'react';
import { DateRangePicker } from 'rsuite';
import addDays from 'date-fns/addDays';

const DateRangePickerComponent = ({ onRangeSelect, quickFilter }) => {
  const [selectedRange, setSelectedRange] = useState([localStorage.getItem('fromDate'), localStorage.getItem('toDate')]);

  useEffect(() => {
    const fromDate = localStorage.getItem('fromDate');
    const toDate = localStorage.getItem('toDate');
    
    // Ensure the fromDate and toDate are valid Date objects, if they exist
    let fromDateObj = fromDate ? new Date(fromDate) : null;
    let toDateObj = toDate ? new Date(toDate) : null;
    
    // Adjust the dates by adding 1 day (to shift the date correctly)
    if (toDateObj) {
      toDateObj = addDays(toDateObj, 1);
    }
    if (fromDateObj) {
      fromDateObj = addDays(fromDateObj, 1);
    }
    // Set the selectedRange to either localStorage values or quickFilter
    if (fromDateObj && toDateObj) {
      setSelectedRange([fromDateObj, toDateObj]);
    }
  }, []);
  
  // useEffect(() => {
  //   if (quickFilter) {
  //     const today = new Date();
  //     let startDate;

  //     // Calculate start date based on quickFilter
  //     switch (quickFilter) {
  //       case 'YTD':
  //         startDate = today.getMonth() >= 3
  //           ? new Date(today.getFullYear(), 3, 1)  // April 1st of the current year
  //           : new Date(today.getFullYear() - 1, 3, 1);  // April 1st of last year
  //         break;
  //       case 'QTD':
  //         const quarterStartMonth = Math.floor(today.getMonth() / 3) * 3;
  //         startDate = new Date(today.getFullYear(), quarterStartMonth, 1);  // First day of the current quarter
  //         break;
  //       case 'MTD':
  //         startDate = new Date(today.getFullYear(), today.getMonth(), 1);  // First day of the current month
  //         break;
  //       case 'WTD':
  //         const weekStart = new Date(today);
  //         weekStart.setDate(today.getDate() - today.getDay());  // Start of the week (Sunday)
  //         startDate = weekStart;
  //         break;
  //       case 'FTD':
  //         startDate = today;  // Today
  //         break;
  //       default:
  //         startDate = null;
  //     }
  //     const endDate = addDays(today, 0);
  //     setSelectedRange([startDate, endDate]);
  //     // Trigger the onRangeSelect callback for quickFilter case
  //     onRangeSelect(startDate, endDate);
  //   }
  // }, [quickFilter, onRangeSelect]);

  const handleChange = (value) => {
    if (Array.isArray(value)) {
      const [startDate, endDate] = value;
      // Add 1 day to the end date for proper adjustment
      const adjustedEndDate = endDate ? addDays(endDate, 0) : null;
      setSelectedRange([startDate, adjustedEndDate]);
      onRangeSelect(startDate, adjustedEndDate);
    } else {
      console.warn('Unexpected value format:', value);
    }
  };

  const handleClean = () => {
    setSelectedRange([null, null]);
    onRangeSelect(null, null);
  };

  return (
    <DateRangePicker
      ranges={[]} // You can provide predefined ranges if needed
      placeholder="Select Date Range"
      style={{ width: 220 }}
      editable={false}
      showHeader={false}
      placement="bottomEnd"
      onChange={handleChange}
      value={selectedRange}
      onClean={handleClean}
      character=" – "
      format="dd/MM/yyyy"
    />
  );
};

export default DateRangePickerComponent;
